import React from 'react';
import useStyle from './eShopButton.style';
import { FlatIcon } from '../../Icons/FlatIcon';

export interface EShopButtonProps {
  onClick?: () => void;
  variant?: 'default' | 'autumn' | 'spring';
  title: string;
}

export const EShopButton = ({
  onClick,
  variant = 'default',
  title
}: EShopButtonProps) => {
  const classes = useStyle();

  return (
    <button onClick={onClick} className={`${classes.root} ${classes[variant]}`}>
      {title}
      <FlatIcon icon="Info" color={'white'} />
    </button>
  );
};
